import { Component } from '@angular/core';
import { NavController, AlertController ,NavParams,ToastController} from 'ionic-angular';
import { Platform } from 'ionic-angular';
import {Storage} from '@ionic/storage';
import {ServiceProvider} from '../../providers/service/service';




@Component({
  selector: 'page-enquiryresponse',
  templateUrl: 'enquiryresponse.html',
})
export class EnquiryresponsePage {
  enquiry_data:any;
  FEResponseId:any;
  eqId:any;


  constructor(public navCtrl: NavController, public service: ServiceProvider, platform: Platform, public storage: Storage,public alertCtrl: AlertController,public navParams: NavParams,public toastCtrl: ToastController) {

    platform.ready().then(() => {


      this.FEResponseId=this.navParams.get('FEResponseId');
      console.log('FEResponseId',this.FEResponseId);
      this.load_values();

    })
  }




  goBack(){
    this.navCtrl.pop();
  }
  load_values() {
    this.service.httpcall('web_service/get_enquiry_response?FEnquiryId='+this.FEResponseId).subscribe(data => {
      console.log(data);
    //  console.log(data.length)
      this.enquiry_data = data;

    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EnquiryresponsePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/enquiryresponse/enquiryresponse.ts